<app-toast></app-toast>
<div class="h-screen flex flex-col items-center p-5 mobile:p-2">
    <!-- Top bar-->
    <div class="w-full max-w-ultrawide">
        <app-admin-topbar></app-admin-topbar>
    </div>

    <!-- Tab Navigation -->
    <div class="w-full max-w-ultrawide">
        <app-admin-navigation [isActiveNumber]="8"></app-admin-navigation>
    </div>

    <!-- Header -->
    <div class="flex gap-2 w-full mt-4 max-w-ultrawide">
        <img src="assets/icons/services/target-green.svg" class="w-[24px] h-[24px]"
            alt="{{ 'shared.icon' | transloco }}">
        <h1 class="font-bold text-xl">
            {{ 'admin.company_opportunity_dashboard' | transloco }}</h1>
    </div>
    <p class="text-neutral-500 self-start mt-2"> {{ 'admin.sales_radars_desc' | transloco }}</p>

    <div class="flex flex-col gap-2 w-full max-w-ultrawide mt-4">
        <!-- Company Opportunity-->
        <app-drop-down-section title="Test Company" titleIcon="assets/icons/admin/building-purple.svg">
            <!-- Actions-->
            <!-- Opportunities TODO: EVuk - Create component -->
            <div header-actions class="flex gap-2 p-2 items-center rounded-full bg-success-200">
                <img src="assets/icons/services/target-green.svg" class="w-[16px] h-[16px]"
                    alt="{{ 'shared.icon' | transloco }}">
                <p class="text-success">2 {{ 'admin.opportunities' | transloco }}</p>
            </div>

            <div class="flex flex-col gap-2 p-5 w-full bg-neutral-100 rounded-b-xl">
                <p class="font-bold">{{ 'admin.active_opportunities' | transloco}}</p>

                <!-- Opportunity -->
                <!-- Opportunities TODO: EVuk - Create component -->
                <div class="flex flex-col gap-2 p-5 w-full bg-[#FFFFFF] border-border shadow-sm rounded-xl">
                    <p class="font-bold text-lg">Contract with new Supplier</p>
                    <p class="text-neutral-500">Product: Commission from new contracts</p>

                    <!-- Separator -->
                    <div class="w-full h-[1px] bg-border my-2"></div>

                    <!--Signal-->
                    <div class="flex gap-2 items-center">
                        <div class="h-[18px] w-[18px] rounded-full bg-success"></div>
                        <p>Contract Ends in less than 90 days</p>
                    </div>
                    <p class="text-sm text-neutral-500">The signal detects all clients with contracts ending in less
                        than 90 days</p>

                    <!-- Contract condition -->
                    <div class="flex flex-col w-full gap-2 bg-neutral-100 p-2 rounded-md mt-2">
                        <p class="text-sm text-neutral-500">{{ 'admin.condition' | transloco }}:</p>
                        <p>If #Remaining Contract Duration &lt;90;true;false</p>

                        <!-- Separator -->
                        <div class="w-full h-[1px] bg-border"></div>
                        <p class="text-sm text-neutral-500">{{ 'admin.current_values' | transloco }}:</p>
                        <p><span class="font-bold">Remaining Contract Duration:</span> 76 days</p>
                    </div>

                    <!-- Indicators -->
                    <div class="flex flex-col w-full gap-2 bg-blue-100 p-2 rounded-md mt-2">
                        <p class="text-sm text-black">{{ 'admin.indicators' | transloco }}:</p>
                        <div class="flex flex-col w-full gap-2 bg-blue-100 p-2 rounded-md">
                            <p class="text-sm">Remaining Contract Duration</p>
                            <p class="text-sm text-neutral-500">The Indicator calculates the remaining contract duration
                                in days</p>

                            <div class="flex flex-col w-full gap-2 bg-neutral-100 p-2 rounded-md">
                                <p class="text-sm text-neutral-500">{{ 'admin.formula' | transloco }}:</p>
                                <p class="text-sm">#Contract End Date-#Today</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </app-drop-down-section>
    </div>
</div>